export const operatorMessages = {
  en: {
    operator: {
      appTitle: 'Machine Operator',
      appDescription: 'Machine status, assigned orders, setup, counters, faults, downtime, maintenance, and efficiency.',
      nav: {
        machines: 'Machines',
        shopfloor: 'Shopfloor',
        efficiency: 'Efficiency',
      },
      machines: {
        eyebrow: 'Machine park',
        title: 'Machines',
        description: 'Current status of all production machines.',
        status: 'Status',
        allStatuses: 'All statuses',
        running: 'Running',
        idle: 'Idle',
        down: 'Down',
        setup: 'Setup',
        machine: 'Machine',
        order: 'Order',
        lot: 'Lot',
        counter: 'Shift counter',
        fault: 'Fault',
        noFault: 'No fault',
        activeFault: 'Fault active',
        actions: 'Actions',
        open: 'Open',
        loading: 'Loading machines…',
        empty: 'No machines found.',
        error: 'Failed to load machines.',
        retry: 'Retry',
        total: '{count} machines',
        runningCount: '{count} running',
        downCount: '{count} down',
        newMachine: 'New machine',
        edit: 'Edit',
        createTitle: 'New machine',
        editTitle: 'Edit machine',
        code: 'Code',
        name: 'Name',
        sortOrder: 'Sort order',
        active: 'Active',
        inactive: 'Inactive',
        save: 'Save machine',
        saving: 'Saving…',
        cancel: 'Cancel',
        created: 'Machine created.',
        updated: 'Machine updated.',
        formRequired: 'Code and name are required.',
      },
      detail: {
        eyebrow: 'Machine',
        back: 'Back to machines',
        title: 'Machine detail',
        status: 'Status',
        running: 'Running',
        idle: 'Idle',
        down: 'Down',
        setup: 'Setup',
        currentOrder: 'Assigned order',
        noOrder: 'No production order assigned.',
        currentLot: 'Current lot',
        counterTotal: 'Total counter',
        counterShift: 'Shift counter',
        assignments: 'Assignments',
        noAssignments: 'No active assignments for this machine.',
        employee: 'Employee',
        stage: 'Stage',
        shift: 'Shift',
        active: 'Active',
        ended: 'Ended',
        setupParameters: 'Setup parameters',
        setupPlaceholder: 'Setup snapshot endpoint is not yet available. Configured parameters will appear here.',
        materialRequirements: 'Yarn & material requirements',
        materialPlaceholder: 'Material requirements endpoint is not yet available.',
        downtime: 'Downtime',
        reportDowntime: 'Report downtime',
        selectReason: 'Select reason',
        report: 'Report',
        reporting: 'Reporting…',
        close: 'Close',
        closeConfirm: 'Close this downtime event?',
        noDowntime: 'No downtime events for this machine.',
        openStatus: 'Open',
        closedStatus: 'Closed',
        resolvedStatus: 'Resolved',
        openItems: '{count} open',
        closedItems: '{count} closed',
        resolvedItems: '{count} resolved',
        doneItems: '{count} done',
        faults: 'Faults',
        reportFault: 'Report fault',
        faultPlaceholder: 'Fault logging endpoint is not yet available.',
        maintenance: 'Maintenance',
        requestMaintenance: 'Request maintenance',
        maintenancePlaceholder: 'Maintenance request endpoint is not yet available.',
        loading: 'Loading machine…',
        error: 'Failed to load machine.',
        retry: 'Retry',
        opened: 'Downtime reported.',
        closed: 'Downtime closed.',
        noSetup: 'No setup snapshot saved for this machine.',
        saveSetup: 'Save setup',
        setupValue: 'Value',
        setupContext: 'Setup context',
        setupReadiness: 'Setup readiness',
        setupReadinessValue: '{count}/{total} checked',
        setupRequired: 'Complete every setup parameter before saving.',
        setupNeedsLot: 'Assign a lot before saving the setup snapshot.',
        setupNotesPlaceholder: 'Optional setup note',
        saving: 'Saving…',
        saved: 'Saved.',
        save: 'Save',
        noRequirements: 'No material requirements for the current order.',
        perPair: 'per pair',
        requiredQuantity: 'Required',
        refreshMaterials: 'Refresh',
        materialContext: 'Material context',
        plannedPairs: 'Planned pairs',
        totalRequired: 'Total required',
        material: 'Material',
        materialsLoading: 'Loading material requirements…',
        noStageRequirements: 'No material requirements for the assigned stage.',
        materialReadiness: 'Material readiness',
        materialReadinessValue: '{count} rows',
        noFaults: 'No faults reported.',
        faultCode: 'Fault code',
        description: 'Description',
        resolve: 'Resolve',
        resolveConfirm: 'Resolve this fault?',
        resolved: 'Fault resolved.',
        faultReported: 'Fault reported.',
        reportFaultPlaceholder: 'e.g. Needle 42 broken',
        noMaintenance: 'No maintenance requests.',
        reason: 'Reason',
        priority: 'Priority',
        priorityLow: 'Low',
        priorityMedium: 'Medium',
        priorityHigh: 'High',
        requested: 'Requested.',
        advance: 'Advance status',
        statusInProgress: 'In progress',
        statusDone: 'Done',
        recordCounter: 'Record counter',
        counterTotalLabel: 'Total counter',
        counterShiftLabel: 'Shift counter',
        counterRecorded: 'Counter recorded.',
        recordingCounter: 'Recording…',
        counterCannotDecrease: 'Counter values cannot be lower than the current readings.',
        counterHint: 'Current total {total}, shift {shift}',
        counterDelta: 'New output: total +{total}, shift +{shift}',
        cancel: 'Cancel',
        notes: 'Notes',
        workflow: 'Operator workflow',
        orderProgress: 'Order progress',
        planned: 'Planned',
        produced: 'Produced',
        remaining: 'Remaining',
        assignedStage: 'Assigned stage',
        assignedLot: 'Assigned lot',
        assignedOperator: 'Assigned operator',
        machineReadiness: 'Machine readiness',
        workflowStates: {
          noOrder: 'No order',
          missingLot: 'Lot required',
          blocked: 'Blocked',
          setup: 'Setup',
          ready: 'Ready',
        },
        workflowHints: {
          noOrder: 'Assign a production order before starting operator work on this machine.',
          missingLot: 'Choose or assign the active lot before recording counters, downtime, or setup checks.',
          blocked: 'Resolve the active fault or downtime state before continuing production on this machine.',
          setup: 'Verify setup parameters, yarn feed, and assigned operator before switching to production.',
          ready: 'The machine has an order and lot context. Continue with counters, downtime, setup, or material checks as needed.',
        },
        setupLabels: {
          needle_count: 'Needle count',
          gauge: 'Gauge',
          tension: 'Tension',
          yarn_feed: 'Yarn feed',
        },
      },
      run: {
        title: 'Machine run',
        runCode: 'Run',
        order: 'Order',
        variant: 'Colour / size',
        stage: 'Stage',
        startedAt: 'Started',
        endedAt: 'Ended',
        duration: 'Duration',
        minutes: '{count} min',
        planned: 'Plan (pairs)',
        produced: 'Produced',
        accepted: 'Accepted',
        rejected: 'Rejected',
        targetRate: 'Target rate (pairs/h)',
        counter: 'Shift counter',
        noRun: 'No machine run is open. Start a run to track this machine’s output.',
        startRun: 'Start run',
        changeover: 'Changeover',
        closeRun: 'Close run',
        machineState: 'Machine state',
        applyState: 'Set state',
        reason: 'Reason',
        reasonPlaceholder: 'Reason code (optional)',
        status: 'Status',
        statusOpen: 'Open',
        history: 'Runs',
        stateHistory: 'State timeline',
        noRuns: 'No runs recorded for this machine yet.',
        noStates: 'No state events recorded yet.',
        color: 'Colour',
        size: 'Size',
        plannedQuantity: 'Planned quantity',
        shift: 'Shift',
        day: 'Day',
        night: 'Night',
        closeReason: 'Close reason',
        closingCounter: 'Closing counter (total)',
        submitting: 'Saving…',
        started: 'Machine run started.',
        changed: 'Changeover recorded.',
        closed: 'Machine run closed.',
        stateChanged: 'Machine state updated.',
        variantRequired: 'Colour and size are required.',
        orderRequired: 'Select a production order.',
        loadingOrders: 'Loading orders…',
        selectOrder: 'Select production order',
        selectVariant: 'Select colour / size',
        selectStage: 'Select stage',
        noVariants: 'This order has no colour / size variants.',
        manualOrderHint: 'Pick the order the operator is currently running on this machine.',
        stageRequired: 'Assign a production stage before starting a run.',
        states: {
          running: 'Running',
          setup: 'Setup',
          idle: 'Idle',
          down: 'Down',
          maintenance: 'Maintenance',
          blocked: 'Blocked',
          off: 'Off',
        },
        closeReasons: {
          completed: 'Completed',
          model_change: 'Model change',
          breakdown: 'Breakdown',
          shift_end: 'Shift end',
          manual: 'Manual',
          order_cancelled: 'Order cancelled',
        },
      },
      efficiency: {
        eyebrow: 'Performance',
        title: 'Machine efficiency',
        description: 'Output efficiency by stage for the selected date.',
        date: 'Date',
        stage: 'Stage',
        completed: 'Completed',
        rejected: 'Rejected',
        rework: 'Rework',
        efficiency: 'Efficiency',
        efficiencyValue: '{percent}%',
        noData: 'No output data for this date.',
        loading: 'Loading efficiency…',
        error: 'Failed to load efficiency.',
        retry: 'Retry',
        totalCompleted: 'Total completed',
        totalRejected: 'Total rejected',
      },
      shopfloor: {
        eyebrow: 'Floor overview',
        title: 'Shopfloor',
        description: 'Interactive floor plan of the machine park. Open a machine to assign its current production order.',
        canvasAria: 'Machine floor plan',
        newLayout: 'New layout',
        addMachine: 'Add machine',
        noLayouts: 'No floor layouts exist yet.',
        nodeCount: '{count} machines',
        machine: 'Machine',
        selectMachine: 'Select machine',
        layoutCode: 'Layout code',
        layoutName: 'Layout name',
        width: 'Width',
        height: 'Height',
        x: 'X',
        y: 'Y',
        save: 'Save',
        saving: 'Saving…',
        cancel: 'Cancel',
        machineRequired: 'Select a machine.',
        layoutRequired: 'Layout code and name are required.',
        machineAdded: 'Machine added to the layout.',
        layoutCreated: 'Layout created.',
        positionSaved: 'Machine position saved.',
        dragHint: 'Drag a machine card to move it — its coordinates are saved automatically.',
        clickHint: 'Click a machine card to open the machine and pick its current order, model, colour and size.',
        refresh: 'Refresh',
        editCoordinates: 'Edit coordinates',
        fullscreen: 'Fullscreen',
        batchAssign: 'Batch assign order',
        batchEyebrow: 'Multi-machine loading',
        batchPageDescription: 'Select machines on the saved floor layout, then assign an order variant and operator to each run.',
        backToShopfloor: 'Back to shopfloor',
        operatorWorker: 'Operator worker',
        selectOperator: 'Select an operator',
        selectMachines: 'Select machines',
        selectedCount: '{count} selected',
        variantMatrix: 'Colour / size matrix',
        assignSelected: 'Assign selected machines',
        batchRequired: 'Select an order, operator, stage, machine and variant.',
        batchVariantRequired: 'Choose the colour/size for the selected machines.',
        batchAssigned: 'Order assigned to {count} machines.',
        batchPartial: '{success} machines assigned; {failed} failed.',
        assignmentSteps: 'Batch assignment steps',
        pickMachinesTab: 'Pick machines',
        assignMatrixTab: 'Assign color / size',
        continueToMatrix: 'Continue to matrix',
        selectMachineFirst: 'Select at least one machine first.',
        selectOrderForMatrix: 'Select an order to load its color and size matrix.',
        tipOrder: 'Order',
        tipProduct: 'Product',
        tipOutput: 'Output today',
        zoomControls: 'Map zoom controls',
        zoomIn: 'Zoom in',
        zoomOut: 'Zoom out',
        zoomFit: 'Fit',
        noMachinesInLayout: 'This floor layout has no machine cards yet. Add machines on the Shopfloor page.',
        mapMode: 'Map interaction mode',
        mapPan: 'Pan',
        mapSelect: 'Box select',
        selectAll: 'Select all',
        clearSelection: 'Clear',
        panHint: 'Drag the map to pan, click machine cards to select several machines, or switch to Box select.',
        marqueeHint: 'Drag a rectangle over the map to select every machine inside it. Hold Shift to add to the selection.',
        assignVariantToAll: 'Assign this colour/size to all selected machines',
        assignVariantToAllHint: 'Click a colour/size column header to assign it to every selected machine, then adjust single rows if needed.',
        batchVariantTitle: 'Colour / size for the batch',
        batchActionLabel: 'Batch action',
        batchActionAssign: 'Assign colour / size',
        batchActionClose: 'Close active runs',
        batchAssignHint: 'Pick machines on the map, then load the same colour/size on all of them. Machines already running are changed over.',
        batchCloseHint: 'Pick the machines to finish, choose the reason and close every active run at once.',
        batchCloseSelected: 'Close selected runs',
        batchCloseNoRuns: 'None of the selected machines has an active run.',
        batchClosed: 'Closed {count} active runs.',
        batchSkipped: '{count} machine(s) skipped.',
        batchNoAssignable: 'No selected machine can take a new order (down, maintenance or off).',
        operatorPickerTitle: 'Select machine operator',
        operatorPickerSearch: 'Search by code, name or position',
        operatorPickerEmpty: 'No operator matches the search.',
        batchVariantHint: 'The same colour/size is loaded on all {count} selected machines. Set a quantity per machine below.',
        quantityForAll: 'Quantity per machine',
        applyToAll: 'Apply to all',
        variantColumn: 'Colour / size',
        machineDetails: 'Machine details',
        closePanel: 'Close machine details',
        currentRun: 'Current order run',
        finishRun: 'Finish current run',
        loadOrder: 'Load new order',
        finishBeforeLoad: 'Finish the current run before loading another order.',
      },
      state: {
        loading: 'Loading…',
        error: 'Something went wrong.',
        retry: 'Retry',
        noData: 'No data available.',
      },
    },
  },
  uz: {
    operator: {
      appTitle: 'Stanok operatori',
      appDescription: 'Stanok holati, tayinlangan buyurtmalar, sozlamalar, hisoblagichlar, nosozliklar, to‘xtalishlar, ta’mirlash va samaradorlik.',
      nav: {
        machines: 'Stanoklar',
        shopfloor: 'Sex xaritasi',
        efficiency: 'Samaradorlik',
      },
      machines: {
        eyebrow: 'Stanok parki',
        title: 'Stanoklar',
        description: 'Barcha ishlab chiqarish stanoklarining joriy holati.',
        status: 'Holat',
        allStatuses: 'Barcha holatlar',
        running: 'Ishlamoqda',
        idle: 'Bo‘sh',
        down: 'To‘xtagan',
        setup: 'Sozlashda',
        machine: 'Stanok',
        order: 'Buyurtma',
        lot: 'Partiya',
        counter: 'Smena hisoblagichi',
        fault: 'Nosozlik',
        noFault: 'Nosozlik yo‘q',
        activeFault: 'Faol nosozlik',
        actions: 'Amallar',
        open: 'Ochish',
        loading: 'Stanoklar yuklanmoqda…',
        empty: 'Stanoklar topilmadi.',
        error: 'Stanoklarni yuklab bo‘lmadi.',
        retry: 'Qayta urinish',
        total: '{count} ta stanok',
        runningCount: '{count} ta ishlamoqda',
        downCount: '{count} ta to‘xtagan',
        newMachine: 'Yangi stanok',
        edit: 'Tahrirlash',
        createTitle: 'Yangi stanok',
        editTitle: 'Stanokni tahrirlash',
        code: 'Kod',
        name: 'Nomi',
        sortOrder: 'Saralash tartibi',
        active: 'Faol',
        inactive: 'Nofaol',
        save: 'Stanokni saqlash',
        saving: 'Saqlanmoqda…',
        cancel: 'Bekor qilish',
        created: 'Stanok yaratildi.',
        updated: 'Stanok yangilandi.',
        formRequired: 'Kod va nom majburiy.',
      },
      detail: {
        eyebrow: 'Stanok',
        back: 'Stanoklarga qaytish',
        title: 'Stanok tafsiloti',
        status: 'Holat',
        running: 'Ishlamoqda',
        idle: 'Bo‘sh',
        down: 'To‘xtagan',
        setup: 'Sozlashda',
        currentOrder: 'Tayinlangan buyurtma',
        noOrder: 'Ishlab chiqarish buyurtmasi tayinlanmagan.',
        currentLot: 'Joriy partiya',
        counterTotal: 'Umumiy hisoblagich',
        counterShift: 'Smena hisoblagichi',
        assignments: 'Taqsimotlar',
        noAssignments: 'Ushbu stanok uchun faol taqsimotlar mavjud emas.',
        employee: 'Xodim',
        stage: 'Bosqich',
        shift: 'Smena',
        active: 'Faol',
        ended: 'Yakunlangan',
        setupParameters: 'Sozlash parametrlari',
        setupPlaceholder: 'Sozlash snapshoti uchun endpoint hali mavjud emas. Sozlangan parametrlar shu yerda ko‘rinadi.',
        materialRequirements: 'Iplar va material talablari',
        materialPlaceholder: 'Material talablari uchun endpoint hali mavjud emas.',
        downtime: 'To‘xtalishlar',
        reportDowntime: 'To‘xtalish haqida xabar berish',
        selectReason: 'Sababni tanlang',
        report: 'Xabar berish',
        reporting: 'Yuborilmoqda…',
        close: 'Yopish',
        closeConfirm: 'Ushbu to‘xtalish hodisasini yopish kerakmi?',
        noDowntime: 'Ushbu stanok uchun to‘xtalish hodisalari mavjud emas.',
        openStatus: 'Ochiq',
        closedStatus: 'Yopilgan',
        resolvedStatus: 'Hal qilingan',
        openItems: '{count} ochiq',
        closedItems: '{count} yopilgan',
        resolvedItems: '{count} hal qilingan',
        doneItems: '{count} bajarilgan',
        faults: 'Nosozliklar',
        reportFault: 'Nosozlik haqida xabar berish',
        faultPlaceholder: 'Nosozliklarni qayd etish uchun endpoint hali mavjud emas.',
        maintenance: 'Ta’mirlash',
        requestMaintenance: 'Ta’mirlash so‘rovi',
        maintenancePlaceholder: 'Ta’mirlash so‘rovi uchun endpoint hali mavjud emas.',
        loading: 'Stanok yuklanmoqda…',
        error: 'Stanokni yuklab bo‘lmadi.',
        retry: 'Qayta urinish',
        opened: 'To‘xtalish qayd etildi.',
        closed: 'To‘xtalish yopildi.',
        noSetup: 'Ushbu stanok uchun sozlash snapshoti saqlanmagan.',
        saveSetup: 'Sozlashni saqlash',
        setupValue: 'Qiymat',
        setupContext: 'Sozlash konteksti',
        setupReadiness: 'Sozlash tayyorligi',
        setupReadinessValue: '{count}/{total} tekshirildi',
        setupRequired: 'Saqlashdan oldin barcha sozlash parametrlarini toldiring.',
        setupNeedsLot: 'Sozlash snapshotini saqlashdan oldin partiyani tayinlang.',
        setupNotesPlaceholder: 'Ixtiyoriy sozlash izohi',
        saving: 'Saqlanmoqda…',
        saved: 'Saqlandi.',
        save: 'Saqlash',
        noRequirements: 'Joriy buyurtma uchun material talablari mavjud emas.',
        perPair: 'jufti uchun',
        requiredQuantity: 'Zarur miqdor',
        refreshMaterials: 'Yangilash',
        materialContext: 'Material konteksti',
        plannedPairs: 'Rejadagi juft',
        totalRequired: 'Jami zarur',
        material: 'Material',
        materialsLoading: 'Material talablari yuklanmoqda…',
        noStageRequirements: 'Tayinlangan bosqich uchun material talablari mavjud emas.',
        materialReadiness: 'Material tayyorligi',
        materialReadinessValue: '{count} qator',
        noFaults: 'Nosozliklar qayd etilmagan.',
        faultCode: 'Nosozlik kodi',
        description: 'Tavsif',
        resolve: 'Hal qilish',
        resolveConfirm: 'Ushbu nosozlikni hal qilish kerakmi?',
        resolved: 'Nosozlik hal qilindi.',
        faultReported: 'Nosozlik qayd etildi.',
        reportFaultPlaceholder: 'Masalan: 42-igna sinib ketdi',
        noMaintenance: 'Ta’mirlash so‘rovlari mavjud emas.',
        reason: 'Sabab',
        priority: 'Ustuvorlik',
        priorityLow: 'Past',
        priorityMedium: 'O‘rta',
        priorityHigh: 'Yuqori',
        requested: 'So‘rov yuborildi.',
        advance: 'Holatni o‘zgartirish',
        statusInProgress: 'Jarayonda',
        statusDone: 'Bajarildi',
        recordCounter: 'Hisoblagichni qayd etish',
        counterTotalLabel: 'Umumiy hisoblagich',
        counterShiftLabel: 'Smena hisoblagichi',
        counterRecorded: 'Hisoblagich qayd etildi.',
        recordingCounter: 'Qayd etilmoqda…',
        counterCannotDecrease: 'Hisoblagich qiymatlari joriy korsatkichlardan kichik bolmasligi kerak.',
        counterHint: 'Joriy umumiy {total}, smena {shift}',
        counterDelta: 'Yangi ishlab chiqarish: umumiy +{total}, smena +{shift}',
        cancel: 'Bekor qilish',
        notes: 'Izohlar',
        workflow: 'Operator jarayoni',
        orderProgress: 'Buyurtma bajarilishi',
        planned: 'Reja',
        produced: 'Ishlab chiqarilgan',
        remaining: 'Qolgan',
        assignedStage: 'Tayinlangan bosqich',
        assignedLot: 'Tayinlangan partiya',
        assignedOperator: 'Tayinlangan operator',
        machineReadiness: 'Stanok tayyorligi',
        workflowStates: {
          noOrder: 'Buyurtma yoq',
          missingLot: 'Partiya kerak',
          blocked: 'Bloklangan',
          setup: 'Sozlash',
          ready: 'Tayyor',
        },
        workflowHints: {
          noOrder: 'Bu stanokda ish boshlashdan oldin ishlab chiqarish buyurtmasini tayinlang.',
          missingLot: 'Hisoblagich, toxtalish yoki sozlashni qayd etishdan oldin faol partiyani tanlang.',
          blocked: 'Ishlab chiqarishni davom ettirishdan oldin faol nosozlik yoki toxtalish holatini hal qiling.',
          setup: 'Ishlab chiqarishga otishdan oldin sozlash parametrlari, ip uzatish va operatorni tekshiring.',
          ready: 'Stanokda buyurtma va partiya konteksti bor. Hisoblagich, toxtalish, sozlash yoki material tekshiruvlarini davom ettiring.',
        },
        setupLabels: {
          needle_count: 'Ignalar soni',
          gauge: 'Gauge',
          tension: 'Taranglik',
          yarn_feed: 'Ip uzatish',
        },
      },
      run: {
        title: 'Stanok ish sikli',
        runCode: 'Ish sikli',
        order: 'Buyurtma',
        variant: 'Rang / o‘lcham',
        stage: 'Bosqich',
        startedAt: 'Boshlandi',
        endedAt: 'Tugadi',
        duration: 'Davomiyligi',
        minutes: '{count} daq.',
        planned: 'Reja (juft)',
        produced: 'Ishlab chiqarilgan',
        accepted: 'Qabul qilingan',
        rejected: 'Rad etilgan',
        targetRate: 'Maqsadli sur’at (juft/soat)',
        counter: 'Smena hisoblagichi',
        noRun: 'Ochiq ish sikli yo‘q. Stanok chiqimini kuzatish uchun ish siklini boshlang.',
        startRun: 'Sikl boshlash',
        changeover: 'Model almashtirish',
        closeRun: 'Siklini yopish',
        machineState: 'Stanok holati',
        applyState: 'Holatni o‘rnatish',
        reason: 'Sabab',
        reasonPlaceholder: 'Sabab kodi (majburiy emas)',
        status: 'Holat',
        statusOpen: 'Ochiq',
        history: 'Ish sikllari',
        stateHistory: 'Holatlar tarixi',
        noRuns: 'Bu stanok uchun hali ish sikli qayd etilmagan.',
        noStates: 'Hali holat hodisalari qayd etilmagan.',
        color: 'Rang',
        size: 'O‘lcham',
        plannedQuantity: 'Reja miqdori',
        shift: 'Smena',
        day: 'Kunduzgi',
        night: 'Tungi',
        closeReason: 'Yopish sababi',
        closingCounter: 'Yopish hisoblagichi (jami)',
        submitting: 'Saqlanmoqda…',
        started: 'Ish sikli boshlandi.',
        changed: 'Model almashtirish qayd etildi.',
        closed: 'Ish sikli yopildi.',
        stateChanged: 'Stanok holati yangilandi.',
        variantRequired: 'Rang va o‘lcham majburiy.',
        orderRequired: 'Ishlab chiqarish buyurtmasini tanlang.',
        loadingOrders: 'Buyurtmalar yuklanmoqda…',
        selectOrder: 'Ishlab chiqarish buyurtmasini tanlang',
        selectVariant: 'Rang / o‘lchamni tanlang',
        selectStage: 'Bosqichni tanlang',
        noVariants: 'Bu buyurtmada rang / o‘lcham variantlari yo‘q.',
        manualOrderHint: 'Operator shu stanokda ishlayotgan buyurtmani tanlang.',
        stageRequired: 'Sikl boshlashdan oldin ishlab chiqarish bosqichini tayinlang.',
        states: {
          running: 'Ishlayapti',
          setup: 'Sozlash',
          idle: 'Bo‘sh',
          down: 'To‘xtagan',
          maintenance: 'Ta’mirlash',
          blocked: 'Bloklangan',
          off: 'O‘chirilgan',
        },
        closeReasons: {
          completed: 'Yakunlangan',
          model_change: 'Model almashtirish',
          breakdown: 'Nosozlik',
          shift_end: 'Smena tugashi',
          manual: 'Qo‘lda',
          order_cancelled: 'Buyurtma bekor qilingan',
        },
      },
      efficiency: {
        eyebrow: 'Ko‘rsatkichlar',
        title: 'Stanok samaradorligi',
        description: 'Tanlangan sana uchun bosqichlar kesimida ishlab chiqarish samaradorligi.',
        date: 'Sana',
        stage: 'Bosqich',
        completed: 'Bajarilgan',
        rejected: 'Rad etilgan',
        rework: 'Qayta ishlash',
        efficiency: 'Samaradorlik',
        efficiencyValue: '{percent}%',
        noData: 'Ushbu sana uchun ishlab chiqarish ma’lumotlari mavjud emas.',
        loading: 'Samaradorlik yuklanmoqda…',
        error: 'Samaradorlikni yuklab bo‘lmadi.',
        retry: 'Qayta urinish',
        totalCompleted: 'Jami bajarilgan',
        totalRejected: 'Jami rad etilgan',
      },
      shopfloor: {
        eyebrow: 'Sex ko‘rinishi',
        title: 'Sex xaritasi',
        description: 'Stanok parkining interaktiv rejasi. Joriy ishlab chiqarish buyurtmasini tayinlash uchun stanokni oching.',
        canvasAria: 'Stanoklar rejasi',
        newLayout: 'Yangi reja',
        addMachine: 'Stanok qo‘shish',
        noLayouts: 'Hali sex rejalari mavjud emas.',
        nodeCount: '{count} ta stanok',
        machine: 'Stanok',
        selectMachine: 'Stanokni tanlang',
        layoutCode: 'Reja kodi',
        layoutName: 'Reja nomi',
        width: 'Kenglik',
        height: 'Balandlik',
        x: 'X',
        y: 'Y',
        save: 'Saqlash',
        saving: 'Saqlanmoqda…',
        cancel: 'Bekor qilish',
        machineRequired: 'Stanokni tanlang.',
        layoutRequired: 'Reja kodi va nomi majburiy.',
        machineAdded: 'Stanok rejaga qo‘shildi.',
        layoutCreated: 'Reja yaratildi.',
        positionSaved: 'Stanok joylashuvi saqlandi.',
        dragHint: 'Stanok kartasini sudrab ko‘chiring — koordinatalari avtomatik saqlanadi.',
        clickHint: 'Stanok kartasini bosing — stanok sahifasi ochiladi va joriy buyurtma, model, rang va o‘lcham tanlanadi.',
        refresh: 'Yangilash',
        editCoordinates: 'Koordinatalarni tahrirlash',
        fullscreen: 'To\'liq ekran',
        batchAssign: 'Buyurtmani guruhli tayinlash',
        batchEyebrow: 'Bir nechta stanokga yuklash',
        batchPageDescription: 'Saqlangan sex rejasidan stanoklarni tanlang, so\'ng har bir siklga buyurtma varianti va operator tayinlang.',
        backToShopfloor: 'Sex xaritasiga qaytish',
        operatorWorker: 'Operator ishchi',
        selectOperator: 'Operatorni tanlang',
        selectMachines: 'Stanoklarni tanlang',
        selectedCount: '{count} ta tanlandi',
        variantMatrix: 'Rang / o\'lcham matritsasi',
        assignSelected: 'Tanlangan stanoklarga tayinlash',
        batchRequired: 'Buyurtma, operator, bosqich, stanok va variantni tanlang.',
        batchVariantRequired: 'Tanlangan stanoklar uchun rang/o‘lchamni tanlang.',
        batchAssigned: 'Buyurtma {count} ta stanokga tayinlandi.',
        batchPartial: '{success} ta stanokga tayinlandi; {failed} ta xato.',
        assignmentSteps: 'Guruhli tayinlash bosqichlari',
        pickMachinesTab: 'Stanoklarni tanlash',
        assignMatrixTab: 'Rang / o\'lcham tayinlash',
        continueToMatrix: 'Matritsaga o\'tish',
        selectMachineFirst: 'Avval kamida bitta stanokni tanlang.',
        selectOrderForMatrix: 'Rang va o\'lcham matritsasini yuklash uchun buyurtmani tanlang.',
        tipOrder: 'Buyurtma',
        tipProduct: 'Mahsulot',
        tipOutput: 'Bugungi chiqim',
        zoomControls: 'Xarita masshtabi boshqaruvlari',
        zoomIn: 'Kattalashtirish',
        zoomOut: 'Kichraytirish',
        zoomFit: 'Sig\'dirish',
        noMachinesInLayout: 'Bu sex rejasida hali stanok kartalari yo‘q. Stanoklarni “Sex xaritasi” sahifasida qo‘shing.',
        mapMode: 'Xarita bilan ishlash tartibi',
        mapPan: 'Surish',
        mapSelect: 'Ramka bilan tanlash',
        selectAll: 'Barchasini tanlash',
        clearSelection: 'Tozalash',
        panHint: 'Xaritani sudrab suring, stanok kartalarini bosib bir nechta stanokni tanlang yoki “Ramka bilan tanlash”ga o‘ting.',
        marqueeHint: 'Xarita ustida to‘g‘ri to‘rtburchak chizing — ichidagi barcha stanoklar tanlanadi. Shift bilan qo‘shimcha tanlash mumkin.',
        assignVariantToAll: 'Bu rang/o‘lchamni barcha tanlangan stanoklarga tayinlash',
        assignVariantToAllHint: 'Rang/o‘lcham ustun sarlavhasini bosing — u barcha tanlangan stanoklarga tayinlanadi, keyin alohida qatorlarni o‘zgartirish mumkin.',
        batchVariantTitle: 'Partiya uchun rang / o‘lcham',
        batchActionLabel: 'Guruhli amal',
        batchActionAssign: 'Rang / o‘lcham tayinlash',
        batchActionClose: 'Faol siklarni yopish',
        batchAssignHint: 'Xaritadan stanoklarni tanlang, so‘ng barchasiga bir xil rang/o‘lcham yuklang. Ishlab turgan stanoklar almashtiriladi.',
        batchCloseHint: 'Yakunlanadigan stanoklarni tanlang, sababni belgilang va barcha faol siklarni bir yo‘la yoping.',
        batchCloseSelected: 'Tanlangan siklarni yopish',
        batchCloseNoRuns: 'Tanlangan stanoklarning hech birida faol sikl yo‘q.',
        batchClosed: '{count} ta faol sikl yopildi.',
        batchSkipped: '{count} ta stanok o‘tkazib yuborildi.',
        batchNoAssignable: 'Tanlangan stanoklarning hech biri yangi buyurtma qabul qila olmaydi (to‘xtagan, ta’mirda yoki o‘chirilgan).',
        operatorPickerTitle: 'Stanok operatorini tanlash',
        operatorPickerSearch: 'Kod, ism yoki lavozim bo‘yicha qidirish',
        operatorPickerEmpty: 'Qidiruvga mos operator topilmadi.',
        batchVariantHint: 'Tanlangan {count} ta stanokning barchasiga bir xil rang/o‘lcham yuklanadi. Har bir stanok uchun miqdorni quyida belgilang.',
        quantityForAll: 'Har bir stanokga miqdor',
        applyToAll: 'Barchasiga qo‘llash',
        variantColumn: 'Rang / o‘lcham',
        machineDetails: 'Stanok ma\'lumotlari',
        closePanel: 'Stanok ma\'lumotlarini yopish',
        currentRun: 'Joriy buyurtma sikli',
        finishRun: 'Joriy siklni yakunlash',
        loadOrder: 'Yangi buyurtma yuklash',
        finishBeforeLoad: 'Boshqa buyurtmani yuklashdan oldin joriy siklni yakunlang.',
      },
      state: {
        loading: 'Yuklanmoqda…',
        error: 'Xatolik yuz berdi.',
        retry: 'Qayta urinish',
        noData: 'Ma’lumot mavjud emas.',
      },
    },
  },
  ru: {
    operator: {
      appTitle: 'Оператор оборудования',
      appDescription: 'Состояние оборудования, назначенные заказы, настройки, счётчики, неисправности, простои, обслуживание и эффективность.',
      nav: {
        machines: 'Оборудование',
        shopfloor: 'Карта цеха',
        efficiency: 'Эффективность',
      },
      machines: {
        eyebrow: 'Парк оборудования',
        title: 'Оборудование',
        description: 'Текущее состояние всего производственного оборудования.',
        status: 'Статус',
        allStatuses: 'Все статусы',
        running: 'Работает',
        idle: 'Простаивает',
        down: 'Остановлено',
        setup: 'Настройка',
        machine: 'Машина',
        order: 'Заказ',
        lot: 'Партия',
        counter: 'Счётчик смены',
        fault: 'Неисправность',
        noFault: 'Нет неисправностей',
        activeFault: 'Активная неисправность',
        actions: 'Действия',
        open: 'Открыть',
        loading: 'Загрузка оборудования…',
        empty: 'Оборудование не найдено.',
        error: 'Не удалось загрузить оборудование.',
        retry: 'Повторить',
        total: '{count} машин',
        runningCount: '{count} работает',
        downCount: '{count} остановлено',
        newMachine: 'Новая машина',
        edit: 'Редактировать',
        createTitle: 'Новая машина',
        editTitle: 'Редактировать машину',
        code: 'Код',
        name: 'Наименование',
        sortOrder: 'Порядок сортировки',
        active: 'Активна',
        inactive: 'Неактивна',
        save: 'Сохранить машину',
        saving: 'Сохранение…',
        cancel: 'Отмена',
        created: 'Машина создана.',
        updated: 'Машина обновлена.',
        formRequired: 'Требуются код и наименование.',
      },
      detail: {
        eyebrow: 'Машина',
        back: 'К оборудованию',
        title: 'Детали машины',
        status: 'Статус',
        running: 'Работает',
        idle: 'Простаивает',
        down: 'Остановлено',
        setup: 'Настройка',
        currentOrder: 'Назначенный заказ',
        noOrder: 'Производственный заказ не назначен.',
        currentLot: 'Текущая партия',
        counterTotal: 'Общий счётчик',
        counterShift: 'Счётчик смены',
        assignments: 'Назначения',
        noAssignments: 'Нет активных назначений для этой машины.',
        employee: 'Сотрудник',
        stage: 'Этап',
        shift: 'Смена',
        active: 'Активен',
        ended: 'Завершено',
        setupParameters: 'Параметры настройки',
        setupPlaceholder: 'Эндпоинт снимка настроек пока недоступен. Настроенные параметры появятся здесь.',
        materialRequirements: 'Требования к пряже и материалам',
        materialPlaceholder: 'Эндпоинт требований к материалам пока недоступен.',
        downtime: 'Простои',
        reportDowntime: 'Сообщить о простое',
        selectReason: 'Выберите причину',
        report: 'Сообщить',
        reporting: 'Отправка…',
        close: 'Закрыть',
        closeConfirm: 'Закрыть этот простой?',
        noDowntime: 'Нет простоев для этой машины.',
        openStatus: 'Открыто',
        closedStatus: 'Закрыто',
        resolvedStatus: 'Решено',
        openItems: '{count} открыто',
        closedItems: '{count} закрыто',
        resolvedItems: '{count} решено',
        doneItems: '{count} готово',
        faults: 'Неисправности',
        reportFault: 'Сообщить о неисправности',
        faultPlaceholder: 'Эндпоинт регистрации неисправностей пока недоступен.',
        maintenance: 'Обслуживание',
        requestMaintenance: 'Запросить обслуживание',
        maintenancePlaceholder: 'Эндпоинт запросов на обслуживание пока недоступен.',
        loading: 'Загрузка машины…',
        error: 'Не удалось загрузить машину.',
        retry: 'Повторить',
        opened: 'Простой зарегистрирован.',
        closed: 'Простой закрыт.',
        noSetup: 'Снимок настроек для этой машины не сохранён.',
        saveSetup: 'Сохранить настройки',
        setupValue: 'Значение',
        setupContext: 'Контекст настройки',
        setupReadiness: 'Готовность настройки',
        setupReadinessValue: '{count}/{total} проверено',
        setupRequired: 'Заполните все параметры настройки перед сохранением.',
        setupNeedsLot: 'Назначьте партию перед сохранением снимка настройки.',
        setupNotesPlaceholder: 'Необязательное примечание к настройке',
        saving: 'Сохранение…',
        saved: 'Сохранено.',
        save: 'Сохранить',
        noRequirements: 'Нет требований к материалам для текущего заказа.',
        perPair: 'за пару',
        requiredQuantity: 'Требуется',
        refreshMaterials: 'Обновить',
        materialContext: 'Контекст материалов',
        plannedPairs: 'План пар',
        totalRequired: 'Всего требуется',
        material: 'Материал',
        materialsLoading: 'Загрузка требований к материалам…',
        noStageRequirements: 'Нет требований к материалам для назначенного этапа.',
        materialReadiness: 'Готовность материалов',
        materialReadinessValue: '{count} строк',
        noFaults: 'Неисправности не зарегистрированы.',
        faultCode: 'Код неисправности',
        description: 'Описание',
        resolve: 'Решить',
        resolveConfirm: 'Решить эту неисправность?',
        resolved: 'Неисправность решена.',
        faultReported: 'Неисправность зарегистрирована.',
        reportFaultPlaceholder: 'напр. Сломалась игла 42',
        noMaintenance: 'Нет запросов на обслуживание.',
        reason: 'Причина',
        priority: 'Приоритет',
        priorityLow: 'Низкий',
        priorityMedium: 'Средний',
        priorityHigh: 'Высокий',
        requested: 'Запрос отправлен.',
        advance: 'Изменить статус',
        statusInProgress: 'В работе',
        statusDone: 'Готово',
        recordCounter: 'Записать счётчик',
        counterTotalLabel: 'Общий счётчик',
        counterShiftLabel: 'Счётчик смены',
        counterRecorded: 'Счётчик записан.',
        recordingCounter: 'Запись…',
        counterCannotDecrease: 'Значения счётчика не могут быть ниже текущих показаний.',
        counterHint: 'Текущий общий {total}, смена {shift}',
        counterDelta: 'Новая выработка: общий +{total}, смена +{shift}',
        cancel: 'Отмена',
        notes: 'Примечания',
        workflow: 'Рабочий процесс оператора',
        orderProgress: 'Выполнение заказа',
        planned: 'План',
        produced: 'Произведено',
        remaining: 'Осталось',
        assignedStage: 'Назначенный этап',
        assignedLot: 'Назначенная партия',
        assignedOperator: 'Назначенный оператор',
        machineReadiness: 'Готовность машины',
        workflowStates: {
          noOrder: 'Нет заказа',
          missingLot: 'Нужна партия',
          blocked: 'Заблокировано',
          setup: 'Настройка',
          ready: 'Готово',
        },
        workflowHints: {
          noOrder: 'Назначьте производственный заказ перед началом работы на этой машине.',
          missingLot: 'Выберите или назначьте активную партию перед записью счетчиков, простоев или проверок настройки.',
          blocked: 'Устраните активную неисправность или простой перед продолжением производства на этой машине.',
          setup: 'Проверьте параметры настройки, подачу пряжи и назначенного оператора перед переходом к производству.',
          ready: 'У машины есть контекст заказа и партии. Продолжайте со счетчиками, простоями, настройкой или проверками материалов.',
        },
        setupLabels: {
          needle_count: 'Количество игл',
          gauge: 'Класс (E)',
          tension: 'Натяжение',
          yarn_feed: 'Подача пряжи',
        },
      },
      run: {
        title: 'Рабочий цикл машины',
        runCode: 'Цикл',
        order: 'Заказ',
        variant: 'Цвет / размер',
        stage: 'Этап',
        startedAt: 'Начало',
        endedAt: 'Окончание',
        duration: 'Длительность',
        minutes: '{count} мин',
        planned: 'План (пар)',
        produced: 'Выпущено',
        accepted: 'Принято',
        rejected: 'Брак',
        targetRate: 'Целевой темп (пар/ч)',
        counter: 'Счётчик смены',
        noRun: 'Нет открытого цикла. Запустите цикл, чтобы отслеживать выработку машины.',
        startRun: 'Запустить цикл',
        changeover: 'Переналадка',
        closeRun: 'Закрыть цикл',
        machineState: 'Состояние машины',
        applyState: 'Задать состояние',
        reason: 'Причина',
        reasonPlaceholder: 'Код причины (необязательно)',
        status: 'Статус',
        statusOpen: 'Открыт',
        history: 'Циклы',
        stateHistory: 'История состояний',
        noRuns: 'Для этой машины ещё нет циклов.',
        noStates: 'События состояний ещё не записаны.',
        color: 'Цвет',
        size: 'Размер',
        plannedQuantity: 'Плановое количество',
        shift: 'Смена',
        day: 'Дневная',
        night: 'Ночная',
        closeReason: 'Причина закрытия',
        closingCounter: 'Счётчик при закрытии (всего)',
        submitting: 'Сохранение…',
        started: 'Цикл машины запущен.',
        changed: 'Переналадка записана.',
        closed: 'Цикл машины закрыт.',
        stateChanged: 'Состояние машины обновлено.',
        variantRequired: 'Укажите цвет и размер.',
        orderRequired: 'Выберите производственный заказ.',
        loadingOrders: 'Загрузка заказов…',
        selectOrder: 'Выберите производственный заказ',
        selectVariant: 'Выберите цвет / размер',
        selectStage: 'Выберите этап',
        noVariants: 'В заказе нет вариантов по цвету / размеру.',
        manualOrderHint: 'Выберите заказ, который оператор выполняет на этой машине.',
        stageRequired: 'Назначьте производственный этап перед запуском цикла.',
        states: {
          running: 'Работает',
          setup: 'Настройка',
          idle: 'Простой',
          down: 'Остановлена',
          maintenance: 'Обслуживание',
          blocked: 'Заблокирована',
          off: 'Выключена',
        },
        closeReasons: {
          completed: 'Завершён',
          model_change: 'Смена модели',
          breakdown: 'Поломка',
          shift_end: 'Конец смены',
          manual: 'Вручную',
          order_cancelled: 'Заказ отменён',
        },
      },
      efficiency: {
        eyebrow: 'Показатели',
        title: 'Эффективность оборудования',
        description: 'Эффективность выработки по этапам за выбранную дату.',
        date: 'Дата',
        stage: 'Этап',
        completed: 'Выполнено',
        rejected: 'Брак',
        rework: 'Переработка',
        efficiency: 'Эффективность',
        efficiencyValue: '{percent}%',
        noData: 'Нет данных о выработке за эту дату.',
        loading: 'Загрузка эффективности…',
        error: 'Не удалось загрузить эффективность.',
        retry: 'Повторить',
        totalCompleted: 'Всего выполнено',
        totalRejected: 'Всего брака',
      },
      shopfloor: {
        eyebrow: 'Обзор цеха',
        title: 'Карта цеха',
        description: 'Интерактивный план парка оборудования. Откройте машину, чтобы назначить текущий производственный заказ.',
        canvasAria: 'План оборудования',
        newLayout: 'Новый план',
        addMachine: 'Добавить машину',
        noLayouts: 'Планов цеха ещё нет.',
        nodeCount: 'Машин: {count}',
        machine: 'Машина',
        selectMachine: 'Выберите машину',
        layoutCode: 'Код плана',
        layoutName: 'Название плана',
        width: 'Ширина',
        height: 'Высота',
        x: 'X',
        y: 'Y',
        save: 'Сохранить',
        saving: 'Сохранение…',
        cancel: 'Отмена',
        machineRequired: 'Выберите машину.',
        layoutRequired: 'Требуются код и название плана.',
        machineAdded: 'Машина добавлена на план.',
        layoutCreated: 'План создан.',
        positionSaved: 'Позиция машины сохранена.',
        dragHint: 'Перетащите карточку машины — координаты сохраняются автоматически.',
        clickHint: 'Нажмите на карточку машины, чтобы открыть машину и выбрать текущий заказ, модель, цвет и размер.',
        refresh: 'Обновить',
        tipOrder: 'Заказ',
        tipProduct: 'Продукт',
        tipOutput: 'Выработка за день',
        zoomControls: 'Управление масштабом карты',
        zoomIn: 'Увеличить',
        zoomOut: 'Уменьшить',
        zoomFit: 'Вписать',
        noMachinesInLayout: 'На этом плане цеха пока нет карточек машин. Добавьте машины на странице «Карта цеха».',
        mapMode: 'Режим работы с картой',
        mapPan: 'Перемещение',
        mapSelect: 'Выделение рамкой',
        selectAll: 'Выбрать все',
        clearSelection: 'Сбросить',
        panHint: 'Перетаскивайте карту, нажимайте на карточки машин для выбора нескольких машин или включите «Выделение рамкой».',
        marqueeHint: 'Нарисуйте прямоугольник на карте — все машины внутри будут выбраны. Shift добавляет к текущему выбору.',
        assignVariantToAll: 'Назначить этот цвет/размер всем выбранным машинам',
        assignVariantToAllHint: 'Нажмите на заголовок колонки цвета/размера, чтобы назначить его всем выбранным машинам, затем при необходимости поправьте отдельные строки.',
        batchVariantTitle: 'Цвет / размер для партии',
        batchActionLabel: 'Групповое действие',
        batchActionAssign: 'Назначить цвет / размер',
        batchActionClose: 'Закрыть активные циклы',
        batchAssignHint: 'Выберите машины на карте и загрузите один цвет/размер на все. Машины в работе будут переведены (changeover).',
        batchCloseHint: 'Выберите машины, укажите причину и закройте все активные циклы сразу.',
        batchCloseSelected: 'Закрыть выбранные циклы',
        batchCloseNoRuns: 'Ни у одной из выбранных машин нет активного цикла.',
        batchClosed: 'Закрыто активных циклов: {count}.',
        batchSkipped: 'Пропущено машин: {count}.',
        batchNoAssignable: 'Ни одна из выбранных машин не может принять новый заказ (остановлена, на ТО или выключена).',
        operatorPickerTitle: 'Выбор оператора машины',
        operatorPickerSearch: 'Поиск по коду, имени или должности',
        operatorPickerEmpty: 'Нет операторов по запросу.',
        batchVariantHint: 'Один и тот же цвет/размер загружается на все выбранные машины ({count}). Количество по каждой машине укажите ниже.',
        quantityForAll: 'Количество на машину',
        applyToAll: 'Применить ко всем',
        variantColumn: 'Цвет / размер',
        machineDetails: 'Данные машины',
        closePanel: 'Закрыть данные машины',
        currentRun: 'Текущий цикл заказа',
        finishRun: 'Завершить текущий цикл',
        loadOrder: 'Загрузить новый заказ',
        finishBeforeLoad: 'Завершите текущий цикл перед загрузкой другого заказа.',
      },
      state: {
        loading: 'Загрузка…',
        error: 'Что-то пошло не так.',
        retry: 'Повторить',
        noData: 'Нет данных.',
      },
    },
  },
}
